/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import styles from './SequenceAdherenceGraphs.module.css';
import TopNRecordsLineGraph from '../TopNRecordsLineGraph/TopNRecordsLineGraph';
import {
  getDayWiseSequenceAdherenceGraphData,
  getWeekWiseSequenceAdherenceGraphData,
  getMonthWiseSequenceAdherenceGraphData,
} from '../../utils/graphDataUtils';
import {
  TIME_DURATION,
  USER_OPERATIONS,
  API_RESOURCE_URLS,
  ASN_STATUS,
} from '../../constants';
import { Table } from '..';
import { downloadCsv } from '../../utils/utils';
import moment from 'moment';
import { buildErrorMessage } from '../../apis/calls';
import { API } from '../../apis/api';
import axios from 'axios';

const SequenceAdherenceGraphs = ({
  durationText,
  startDateTime,
  endDateTime,
  plant,
  line,
  puneChassisLines,
  jamshedpurChassisLines,
  dharwadChassisLines,
  lukhnowChassisLines,
}) => {
  const ROW_HEIGHT = 38;

  const [puneSequenceAdherenceData, setPuneSequenceAdherenceData] = useState(
    [],
  );
  const [puneGraphLoading, setPuneGraphLoading] = useState(true);

  const [
    jamshedpurSequenceAdherenceData,
    setJamshedpurSequenceAdherenceData,
  ] = useState([]);
  const [jamshedpurGraphLoading, setJamshedpurGraphLoading] = useState(true);

  const [
    dharwadSequenceAdherenceData,
    setDharwadSequenceAdherenceData,
  ] = useState([]);
  const [dharwadGraphLoading, setDharwadGraphLoading] = useState(true);

  const [
    lukhnowSequenceAdherenceData,
    setLukhnowSequenceAdherenceData,
  ] = useState([]);
  const [lukhnowGraphLoading, setLukhnowGraphLoading] = useState(true);

  const fetchDataForPlant = async (
    lines,
    start,
    end,
    APICancelTokenSource,
    plant,
    setData,
  ) => {
    await Promise.all(
      lines.map(async line => {
        const response = await API.get(
          API_RESOURCE_URLS.SEQUENCE_ADHERENCE_STATISTICS,
          {
            params: {
              plant: plant?.value,
              line: line?.value,
              from: start,
              to: end,
            },
            cancelToken: APICancelTokenSource.token,
          },
        );
        return {
          line: line,
          data: response.data,
        };
      }),
    ).then(res => {
      setData(res);
    });
  };

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();
    fetchDataForPlant(
      puneChassisLines,
      startDateTime,
      endDateTime,
      cancelTokenSource,
      { value: 1001 },
      setPuneSequenceAdherenceData,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [puneChassisLines, startDateTime, endDateTime]);

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();
    fetchDataForPlant(
      jamshedpurChassisLines,
      startDateTime,
      endDateTime,
      cancelTokenSource,
      { value: 2001 },
      setJamshedpurSequenceAdherenceData,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jamshedpurChassisLines, startDateTime, endDateTime]);

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();
    fetchDataForPlant(
      dharwadChassisLines,
      startDateTime,
      endDateTime,
      cancelTokenSource,
      { value: 1500 },
      setDharwadSequenceAdherenceData,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dharwadChassisLines, startDateTime, endDateTime]);

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();
    fetchDataForPlant(
      lukhnowChassisLines,
      startDateTime,
      endDateTime,
      cancelTokenSource,
      { value: 3001 },
      setLukhnowSequenceAdherenceData,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lukhnowChassisLines, startDateTime, endDateTime]);

  const [puneGraphData, setPuneGraphData] = useState([]);
  const [jamshedpurGraphData, setJamshedpurGraphData] = useState([]);
  const [dharwadGraphData, setDharwadGraphData] = useState([]);
  const [lukhnowGraphData, setLukhnowGraphData] = useState([]);

  useEffect(() => {
    setPuneGraphLoading(true);
    const dataForPune =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWiseSequenceAdherenceGraphData(puneSequenceAdherenceData)
        : durationText === TIME_DURATION.LAST_FOUR_WEEKS
        ? getWeekWiseSequenceAdherenceGraphData(
            puneSequenceAdherenceData,
            startDateTime,
          )
        : getMonthWiseSequenceAdherenceGraphData(
            puneSequenceAdherenceData,
            startDateTime,
          );
    setPuneGraphData(dataForPune);
    setPuneGraphLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [puneSequenceAdherenceData, durationText]);

  useEffect(() => {
    setJamshedpurGraphLoading(true);
    const dataForJamshedpur =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWiseSequenceAdherenceGraphData(jamshedpurSequenceAdherenceData)
        : durationText === TIME_DURATION.LAST_FOUR_WEEKS
        ? getWeekWiseSequenceAdherenceGraphData(
            jamshedpurSequenceAdherenceData,
            startDateTime,
          )
        : getMonthWiseSequenceAdherenceGraphData(
            jamshedpurSequenceAdherenceData,
            startDateTime,
          );
    setJamshedpurGraphData(dataForJamshedpur);
    setJamshedpurGraphLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jamshedpurSequenceAdherenceData, durationText]);

  useEffect(() => {
    setDharwadGraphLoading(true);
    const dataForDharwad =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWiseSequenceAdherenceGraphData(dharwadSequenceAdherenceData)
        : durationText === TIME_DURATION.LAST_FOUR_WEEKS
        ? getWeekWiseSequenceAdherenceGraphData(
            dharwadSequenceAdherenceData,
            startDateTime,
          )
        : getMonthWiseSequenceAdherenceGraphData(
            dharwadSequenceAdherenceData,
            startDateTime,
          );
    setDharwadGraphData(dataForDharwad);
    setDharwadGraphLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dharwadSequenceAdherenceData, durationText]);

  useEffect(() => {
    setLukhnowGraphLoading(true);
    const dataForLucknow =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWiseSequenceAdherenceGraphData(lukhnowSequenceAdherenceData)
        : durationText === TIME_DURATION.LAST_FOUR_WEEKS
        ? getWeekWiseSequenceAdherenceGraphData(
            lukhnowSequenceAdherenceData,
            startDateTime,
          )
        : getMonthWiseSequenceAdherenceGraphData(
            lukhnowSequenceAdherenceData,
            startDateTime,
          );
    setLukhnowGraphData(dataForLucknow);
    setLukhnowGraphLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lukhnowSequenceAdherenceData, durationText]);

  const baseDefaultColumns = [
    {
      width: 120,
      title: 'ASN',
      field: 'asn',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: 'VC',
      field: 'vc',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: 'VC Description',
      field: 'vcDescription',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: 'Shift',
      field: 'shiftName',
      enableSearch: true,
      enableFilter: true,
      render: ({ shiftName }) => (
        <div style={{ textAlign: 'center' }}>
          {shiftName && <div className={styles.shift}>{shiftName}</div>}
        </div>
      ),
    },
    {
      width: 150,
      title: 'Reason',
      field: 'lineOutReason',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: 'Agency',
      field: 'lineOutAgency',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: 'Linedout At',
      field: 'lastLinedOutAt',
      render: row =>
        row.lastLinedOutAt
          ? moment(row.lastLinedOutAt).format('hh:mm A DD/MM/YYYY')
          : null,
      enableSearch: true,
      enableFilter: true,
    },
  ].filter(c => c);

  const prepareJsonHeaderAndValueFormats = () => {
    const vcHeaderAndValueFormats = [
      {
        label: 'ASN',
        value: row => row.asn,
      },
      {
        label: 'VC',
        value: row => row.vc,
      },
      {
        label: 'VC Description',
        value: row => row.vcDescription?.replace(/[\n\r,]/g, ''),
      },
      {
        label: 'Shift',
        value: row => row.shiftName,
      },
      {
        label: 'Reason',
        value: row => row.reason,
      },
      {
        label: 'Agency',
        value: row => row.agency,
      },
      {
        label: 'Linedout At',
        value: row =>
          row.lastLinedOutAt
            ? moment(row.lastLinedOutAt).format('hh:mm A DD/MM/YYYY')
            : null,
      },
    ];

    return [...vcHeaderAndValueFormats];
  };

  const generateAndDownloadLineoutCsvReport = filteredData => {
    try {
      if (!lineOutRowsData.loading) {
        const jsonData = filteredData;
        const { parseAsync } = require('json2csv');
        const fields = prepareJsonHeaderAndValueFormats();
        const opts = { fields, quote: '' };
        parseAsync(jsonData, opts)
          .then(csv => {
            const exportedFilename =
              'LineOutReport_' + plant.label + '_' + line.label + '.csv';
            downloadCsv(csv, exportedFilename);
          })
          .catch(error =>
            console.error(
              'Failed to download lineout report, error:' +
                buildErrorMessage(error),
            ),
          );
      }
    } catch (error) {
      console.error(
        'Failed to download lineout report, error:' + buildErrorMessage(error),
      );
    }
  };

  const [lineOutRowsData, setLineOutRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });

  const fetchLineOutAsnsForDateRange = async (
    plantId,
    fromDateString,
    toDateString,
    asnStatus,
    lineId,
  ) => {
    let addIdFieldToData = [];
    const response = await API.get(
      API_RESOURCE_URLS.getLinedOutChassis(plantId, lineId),
      {
        params: {
          status: asnStatus,
          plant: plantId,
          line: lineId,
        },
      },
    );
    const dataOfGivenDateRange = response?.data.filter(record => {
      const linedOutDate = moment(record.lastLinedOutAt);
      const fromDate = moment(fromDateString);
      if (linedOutDate.isAfter(fromDate)) {
        return record;
      }
    });
    addIdFieldToData = dataOfGivenDateRange?.map(record => ({
      ...record,
      id: Math.random(),
    }));
    return addIdFieldToData;
  };

  useEffect(() => {
    if (plant?.value !== '9000') {
      if (line?.value === '9000') {
        if (plant?.value === '2001') {
          setLineOutRowsData({
            loading: true,
            data: [],
            filteredData: [],
          });
          jamshedpurChassisLines.map(line => {
            fetchLineOutAsnsForDateRange(
              plant?.value,
              startDateTime,
              endDateTime,
              ASN_STATUS.LINE_OUT,
              line?.value,
            ).then(res => {
              setLineOutRowsData(prev => ({
                loading: false,
                data: [...prev.data, ...res],
                filteredData: [...prev.filteredData, ...res],
              }));
            });
          });
        }
        if (plant?.value === '1001') {
          setLineOutRowsData({
            loading: true,
            data: [],
            filteredData: [],
          });
          puneChassisLines.map(line => {
            fetchLineOutAsnsForDateRange(
              plant?.value,
              startDateTime,
              endDateTime,
              ASN_STATUS.LINE_OUT,
              line?.value,
            ).then(res => {
              setLineOutRowsData(prev => ({
                loading: false,
                data: [...prev.data, ...res],
                filteredData: [...prev.filteredData, ...res],
              }));
            });
          });
        }
        if (plant?.value === '1500') {
          setLineOutRowsData({
            loading: true,
            data: [],
            filteredData: [],
          });
          dharwadChassisLines.map(line => {
            fetchLineOutAsnsForDateRange(
              plant?.value,
              startDateTime,
              endDateTime,
              ASN_STATUS.LINE_OUT,
              line?.value,
            ).then(res => {
              setLineOutRowsData(prev => ({
                loading: false,
                data: [...prev.data, ...res],
                filteredData: [...prev.filteredData, ...res],
              }));
            });
          });
        }
        if (plant?.value === '3001') {
          setLineOutRowsData({
            loading: true,
            data: [],
            filteredData: [],
          });
          lukhnowChassisLines.map(line => {
            fetchLineOutAsnsForDateRange(
              plant?.value,
              startDateTime,
              endDateTime,
              ASN_STATUS.LINE_OUT,
              line?.value,
            ).then(res => {
              setLineOutRowsData(prev => ({
                loading: false,
                data: [...prev.data, ...res],
                filteredData: [...prev.filteredData, ...res],
              }));
            });
          });
        }
      } else {
        fetchLineOutAsnsForDateRange(
          plant?.value,
          startDateTime,
          endDateTime,
          ASN_STATUS.LINE_OUT,
          line?.value,
        ).then(res =>
          setLineOutRowsData({
            loading: false,
            data: res,
            filteredData: res,
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDateTime, line, plant, startDateTime]);

  return (
    <div>
      {plant?.label === 'ALL' ? (
        <div className={styles.plantGraphsContainer}>
          <div className={styles.plantsGraphs}>
            <div className={styles.heading}>Pune</div>
            <TopNRecordsLineGraph
              data={puneGraphData}
              durationText={durationText}
              isLoading={puneGraphLoading}
              maxRecordCount={100}
            />
          </div>
          <div className={styles.plantsGraphs}>
            <div className={styles.heading}>Jamshedpur</div>
            <TopNRecordsLineGraph
              data={jamshedpurGraphData}
              durationText={durationText}
              isLoading={jamshedpurGraphLoading}
              maxRecordCount={100}
            />
          </div>
          <div className={styles.plantsGraphs}>
            <div className={styles.heading}>Dharwad</div>
            <TopNRecordsLineGraph
              data={dharwadGraphData}
              durationText={durationText}
              isLoading={dharwadGraphLoading}
              maxRecordCount={100}
            />
          </div>
          <div className={styles.plantsGraphs}>
            <div className={styles.heading}>Lucknow</div>
            <TopNRecordsLineGraph
              data={lukhnowGraphData}
              durationText={durationText}
              isLoading={lukhnowGraphLoading}
              maxRecordCount={100}
            />
          </div>
        </div>
      ) : (
        <>
          {plant.label === 'Pune' && (
            <div className={styles.topNRecordsLineGraph}>
              <div className={styles.heading}>{plant?.label}</div>
              <TopNRecordsLineGraph
                data={
                  line.value !== '9000'
                    ? puneGraphData.filter(record => record.id === line.label)
                    : puneGraphData
                }
                durationText={durationText}
                isLoading={puneGraphLoading}
                maxRecordCount={100}
              />
            </div>
          )}
          {plant.label === 'Jamshedpur' && (
            <div className={styles.topNRecordsLineGraph}>
              <div className={styles.heading}>{plant?.label}</div>
              <TopNRecordsLineGraph
                data={
                  line.value !== '9000'
                    ? jamshedpurGraphData.filter(
                        record => record.id === line.label,
                      )
                    : jamshedpurGraphData
                }
                durationText={durationText}
                isLoading={jamshedpurGraphLoading}
                maxRecordCount={100}
              />
            </div>
          )}
          {plant.label === 'Dharwad' && (
            <div className={styles.topNRecordsLineGraph}>
              <div className={styles.heading}>{plant?.label}</div>
              <TopNRecordsLineGraph
                data={
                  line.value !== '9000'
                    ? dharwadGraphData.filter(
                        record => record.id === line.label,
                      )
                    : dharwadGraphData
                }
                durationText={durationText}
                isLoading={dharwadGraphLoading}
                maxRecordCount={100}
              />
            </div>
          )}
          {plant.label === 'Lucknow' && (
            <div className={styles.topNRecordsLineGraph}>
              <div className={styles.heading}>{plant?.label}</div>
              <TopNRecordsLineGraph
                data={
                  line.value !== '9000'
                    ? lukhnowGraphData.filter(
                        record => record.id === line.label,
                      )
                    : lukhnowGraphData
                }
                durationText={durationText}
                isLoading={lukhnowGraphLoading}
                maxRecordCount={100}
              />
            </div>
          )}
          <div className={styles.container}>
            <div className={styles.tableHeading}>
              Non-Adherence Contributors
            </div>
            <div className={styles.tableView} style={{ height: '100%' }}>
              <Table
                columns={[...baseDefaultColumns]}
                defaultColumns={[...baseDefaultColumns]}
                rowHeight={ROW_HEIGHT}
                rows={lineOutRowsData.data}
                downloadActions={[
                  {
                    name: 'DOWNLOAD CSV',
                    getFilteredData: true,
                    authOperation: USER_OPERATIONS.GET_CHASSIS_PLAN_ASN,
                    isDisabled: lineOutRowsData.data.length <= 0 ? true : false,
                    actionFn: filteredData => {
                      const dataAfterCleaning = filteredData.map(record => ({
                        asn: record.asn,
                        vc: record.vc,
                        vcDescription: record.vcDescription,
                        shiftName: record.shiftName,
                        reason: record.lineOutReason,
                        agency: record.lineOutAgency,
                        lastLinedOutAt: record.lastLinedOutAt,
                      }));
                      generateAndDownloadLineoutCsvReport(dataAfterCleaning);
                    },
                  },
                ]}
                setHasActiveEdits={() => false}
                setAsnCount={() => true}
                isDataLoading={lineOutRowsData.loading}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SequenceAdherenceGraphs;
